// src/App.js
import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';

import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import VerificadoPage from './VerificadoPage';
import ProfilePage from './ProfilePage';
import AdminPanelPage from './admin/AdminPanelPage';
import CategoriaApostaPage from './pages/CategoriaApostaPage';
import ModoApostaPage from "./pages/ModoApostaPage";
import ProfilePublicPage from './ProfilePublicPage';

// ✅ bridges
import HistoryBridge from './components/HistoryBridge';
import AuthBridge from './components/AuthBridge';   // << ADICIONE isto

function App() {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, () => {});
    return () => unsubscribe();
  }, []);

  return (
    <Router>
      {/* ✅ dentro do Router, antes das rotas */}
      <HistoryBridge />
      <AuthBridge />      {/* << ADICIONE isto */}

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/registrar" element={<RegisterPage />} />
        <Route path="/verificado" element={<VerificadoPage />} />
        <Route path="/perfil" element={<ProfilePage />} />
        <Route path="/perfil-publico/:uid" element={<ProfilePublicPage />} />
        <Route path="/admin" element={<AdminPanelPage />} />
        <Route path="/perfil/:modo/:categoria" element={<CategoriaApostaPage />} />
        <Route path="/perfil/:modo" element={<ModoApostaPage />} />
      </Routes>
    </Router>
  );
}

export default App;
